(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-home-oficial"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('[data-vrp-tv]').forEach(tv=>{const s=[...tv.querySelectorAll('article')],d=tv.querySelector('.dots');let i=0,t;const show=n=>{i=(n+s.length)%s.length;s.forEach((x,j)=>x.classList.toggle('active',j===i));[...d.children].forEach((x,j)=>x.classList.toggle('active',j===i))};s.forEach((_,j)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Ver destaque '+(j+1));b.onclick=()=>show(j);d.appendChild(b)});tv.querySelector('.prev').onclick=()=>show(i-1);tv.querySelector('.next').onclick=()=>show(i+1);show(0);if(!matchMedia('(prefers-reduced-motion: reduce)').matches)t=setInterval(()=>show(i+1),6500)})})()
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-loja-online-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initMonitor = (root) => {
    if (!root || root.dataset.vrlReady === 'true') return;
    root.dataset.vrlReady = 'true';
    const slides = [...root.querySelectorAll('.vrl-monitor-slide')];
    const dotsWrap = root.querySelector('[data-vrl-dots]');
    const prev = root.querySelector('[data-vrl-prev]');
    const next = root.querySelector('[data-vrl-next]');
    if (!slides.length || !dotsWrap) return;

    let index = 0;
    let timer = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Ver destaque ${i + 1}`);
      dot.addEventListener('click', () => show(i));
      dotsWrap.appendChild(dot);
    });

    const dots = [...dotsWrap.querySelectorAll('button')];

    const stopVideos = () => {
      slides.forEach(slide => {
        const video = slide.querySelector('video');
        if (video) video.pause();
      });
    };

    const schedule = () => {
      clearTimeout(timer);
      if (reduceMotion) return;
      const active = slides[index];
      const video = active.querySelector('video');
      let delay = 6200;
      if (video) {
        const duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration * 1000 : 9000;
        delay = Math.min(Math.max(duration, 6000), 18000);
      }
      timer = setTimeout(() => show(index + 1), delay);
    };

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      stopVideos();
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      const video = slides[index].querySelector('video');
      if (video) {
        try { video.currentTime = 0; } catch (_) {}
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        video.addEventListener('ended', () => show(index + 1), { once: true });
      }
      schedule();
    };

    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    root.addEventListener('mouseenter', () => clearTimeout(timer));
    root.addEventListener('mouseleave', schedule);
    root.addEventListener('focusin', () => clearTimeout(timer));
    root.addEventListener('focusout', schedule);

    show(0);
  };

  const start = (scope = document) => scope.querySelectorAll('[data-vrl-monitor]').forEach(initMonitor);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start()); else start();
  document.addEventListener('shopify:section:load', e => start(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
